import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { PORTAL_ONBOARDING_PHASE, PORTAL_ONBOARDING_STEPS } from '../portal-onboarding.const'

import { portalOnboardingInitialState } from './portal-onboarding.slice'
import type { PortalOnboardingStore } from './portal-onboarding.type'

export const usePortalOnboardingStore = create<PortalOnboardingStore>()(
  devtools(
    immer((set) => ({
      ...portalOnboardingInitialState,

      openWelcome: () =>
        set((state) => {
          state.phase = PORTAL_ONBOARDING_PHASE.welcome
          state.currentStepIndex = 0
        }),

      startTour: () =>
        set((state) => {
          state.phase = PORTAL_ONBOARDING_PHASE.active
          state.currentStepIndex = 0
        }),

      nextStep: () =>
        set((state) => {
          if (state.currentStepIndex >= PORTAL_ONBOARDING_STEPS.length - 1) {
            state.phase = PORTAL_ONBOARDING_PHASE.completed
            return
          }

          state.currentStepIndex += 1
        }),

      previousStep: () =>
        set((state) => {
          if (state.currentStepIndex <= 0) return
          state.currentStepIndex -= 1
        }),

      dismiss: () =>
        set((state) => {
          state.phase = PORTAL_ONBOARDING_PHASE.idle
          state.currentStepIndex = 0
        }),

      complete: () =>
        set((state) => {
          state.phase = PORTAL_ONBOARDING_PHASE.completed
        }),

      reset: () =>
        set((state) => {
          state.phase = PORTAL_ONBOARDING_PHASE.idle
          state.currentStepIndex = 0
        }),
    })),
    {
      name: StoreDevtoolsName.PortalOnboarding,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
